import { apiHost } from '@/config/routes'
import axios from 'axios'

export const notyService = {};

notyService.markAsRead = async (data) => {
  try {
    const url = `${apiHost}/channel/api/notifications/markasread`
    const response = await axios.post(url, data)

    if (response.status != 200) {
      return new Error('Error al actualizar notificacion')
    }

    return response.data.message
  } catch (error) {
    console.error("Error mark as read: ", error)
    return new Error(error)
  }
}

export const notificationsService = {
  connect(token, onMessage, onError) {
    const source = new EventSource(`${apiHost}/channel/api/notifications/stream?token=${token}`);

    source.onmessage = (event) => {
      const data = JSON.parse(event.data);
      onMessage(data); // <- callback que manejará el front
    };

    source.onerror = (error) => {
      console.warn('⚠️ Error SSE, cerrando conexión...');
      source.close();
      if (onError) onError(error);
    };

    return source; // <- devolvemos el objeto por si quieres cerrarlo luego
  }
};

//noticias

export const newsService = {};

newsService.markAsRead = async (data) => {
  try {
    const url = `${apiHost}/channel/api/news/markasread`
    const response = await axios.post(url, data)

    if (response.status != 200) {
      return new Error('Error al marcar como leida la noticia')
    }

    return response.data.message
  } catch (error) {
    console.error("Error news mark as read: ", error)
    return new Error(error)
  }
}

newsService.wasUsefull = async (data) => {
  try {
    const url = `${apiHost}/channel/api/news/wasusefull`
    const response = await axios.post(url, data)

    if (response.status != 200) {
      return new Error('Error al marcar como útil la noticia')
    }

    return response.data.message
  } catch (error) {
    console.error("Error news was usefull: ", error)
    return new Error(error)
  }
}


